import { template as template_798969c3f9f54ceb85dc3ffb3a46790e } from "@ember/template-compiler";
import Component from '@glimmer/component';
import styles from './panel-loading-state.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
export default class RequestClinicianSearchFiltersPanelLoadingState extends Component {
    styles = styles;
    static{
        template_798969c3f9f54ceb85dc3ffb3a46790e(`
    <div class={{this.styles.loadingState}} role="status" aria-live="polite" ...attributes>
      {{svgJar "circle-notch" class="icon-spinner" aria-label=@ariaLabel}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
